module.exports = __webpack_public_path__ + "img/post-bg.21b929b3.jpg";